export const REGISTRATION_STEP_KEY = 'registration-step';
export const SPECIAL_CHARACTERS_ALLOWED = /(?=.*[\.\-\_!?\@$%*#:\(\)=\+^<>])/g;
export const PASSWORD_VALIDATION_REGEX =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[-._!@#$%*?#:()=+^<>])[-._A-Za-z0-9!@#$%*?#:()=+^<>]{8,}$/;
export const USERNAME_VALIDATION_REGEX = /^[a-zA-Z0-9._@$-]+$/;
